import React from "react";
import { Outlet } from 'react-router-dom';
import UserRoles from '../../../hooks/userRoles';
import MemberHeader from "../../MemberPortal/Header/MemberHeader";
import MemberSidebar from "../Sidebar/MemberSidebar";
import Footer from "../../MemberPortal/Footer/Footer";


const MemberLayout = () => {

  return (
    <div className="wrapper">
      <MemberHeader  />
      <MemberSidebar allowedRoles={UserRoles} />
      <div className="content-wrapper">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default MemberLayout;
